import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const routes = [
    {
        path: '*',
        redirect: '/about'
    },
    {
        name: 'home',
        component: () => import('../views/index'),
        meta: {
            title: '首页'
        }
    },
    {
        name: 'about',
        component: () => import('../views/about'),
        meta: {
            title: '关于我们'
        }
    },
    {
        name: 'newsDetail',
        component: () => import('../views/news/detail'),
        meta: {
            title: '新闻详情页'
        }
    },
    {
        name: 'health_heartRate',
        component: () => import('../views/health/heartRate'),
    },
    {
        name: 'health_bloodPressure',
        component: () => import('../views/health/bloodPressure'),
    },
    {
        name: 'health_bloodOxygen',
        component: () => import('../views/health/bloodOxygen'),
    },
    {
        name: 'health_bloodSugar',
        component: () => import('../views/health/bloodSugar'),
    },
    {
        name: 'health_motion',
        component: () => import('../views/health/motion'),
    },
    {
        name: 'health_dailyPaper',
        component: () => import('../views/health/dailyPaper'),
    },
    {
        name: 'health_weeklyPaper',
        component: () => import('../views/health/weeklyPaper'),
    },
    {
        name: 'cardio_detail',
        component: () => import('../views/cardio/detail'),
        meta: {
            title: 'ECG心电报告'
        }
    }
];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

export default router;

